const securitySchemeMutators = (target) => {
  const addSecurityScheme = (name, securityScheme) => {
    if (!target) {
      return false;
    }
    if (target[name]) {
      return false;
    }
    target[name] = securityScheme;
    return true;
  };
  const deleteSecurityScheme = (name) => {
    if (!target || !target[name]) {
      return false;
    }
    delete target[name];
    return true;
  };
  return {
    addSecurityScheme,
    deleteSecurityScheme
  };
};
export {
  securitySchemeMutators
};
//# sourceMappingURL=security-schemes.js.map
